<mat-form-field class="w-100" [ngClass]="{ mgn: control?.isReadonly }">
  @if (helpText) {
    <app-help-text [dataContext]="helpText"></app-help-text>
  }
  <textarea
    rows="{{ rows }}"
    matInput
    [formControl]="control"
    [placeholder]="control.caption | translate"
    [required]="control.required ? true : null"
    [readonly]="control.isReadonly ? true : null"
    [ngClass]="{ locked: control?.isReadonly }"
    (blur)="onblur()"
    (focus)="onfocus()"
    (keydown)="onKeyDown($event)"
    (input)="onInput($event)"
    >
  </textarea>
  @if (errorMessage) {
    <mat-error>{{ errorMessage.message | translate: errorMessage.params }}</mat-error>
  }
</mat-form-field>
